module.exports = __webpack_public_path__ + "img/icon-schedule.e8ce7451.svg";